var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#1063ac;}.cls-2{fill:#fff;fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 16,
    height: 16,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M11.6,4.45a5.29,5.29,0,0,0-2.66.68c.07.1.15.18.23.28a2.73,2.73,0,0,1,.56,1.72V7.3A1.72,1.72,0,0,1,11,6.72a1,1,0,0,1,1,1.35,1.76,1.76,0,0,1-1.7,1.34,1.07,1.07,0,0,1-1-.56,4.93,4.93,0,0,1-1.82,2.08,4.05,4.05,0,0,0,2.26.66,5,5,0,0,0,5-3.52c.53-2.18-.93-3.59-3.14-3.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M6.22,4.41a5.84,5.84,0,0,0-.93.08A4.87,4.87,0,0,0,1.27,8c-.56,2.23.93,3.57,3.16,3.59a6.4,6.4,0,0,0,.87-.08A4.76,4.76,0,0,0,9.35,8c.56-2.18-.9-3.59-3.13-3.61M6.68,8A1.76,1.76,0,0,1,5.3,9.34a1.88,1.88,0,0,1-.34,0A1,1,0,0,1,3.93,8,1.81,1.81,0,0,1,5.3,6.72a2.23,2.23,0,0,1,.36,0A1,1,0,0,1,6.68,8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/Icon.e753e6304441e7c320f50c96432a0784.svg";
export { ForwardRef as ReactComponent };